<form
  [formGroup]="form"
  (ngSubmit)="onSavePassword()"
>
  <p class="lato blue">Change your password using the form below:</p>

  <div class="input-container mb-1 pb-1">
    <span class="input-label">Current Password</span>
    <app-password-input id="currentPassword" formControlName="password"></app-password-input>
    <span
      class="error"
      *ngIf="f.password.touched && f.password.value === ''"
    >Please enter password.</span>
  </div>

  <hr>

  <app-password-form
    #appPasswordForm
    formControlName="passwordForm"
  ></app-password-form>

  <div class="action-container">
    <button
      type="submit"
      class="btn btn-danger btn-block"
      [disabled]="form.invalid"
    >Save</button>
  </div>
</form>